import { LAYOUT } from '@admin/router/constant'

// plm工作流设置
const plmWorkflowSetupRouter = {
  path: '/archivesManagement',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/archives-management/product-development-file',
      name: 'productDevelopmentFileList',
      component: () =>
        import('@admin/views/plm/archivesManagement/productDevelopmentFile/list/index.vue'),
      meta: { helpUrl: '', title: '商品开发档案' },
    },
    {
      path: '/archives-management/product-development-file/detail',
      name: 'productDevelopmentFileDetail',
      component: () =>
        import('@admin/views/plm/archivesManagement/productDevelopmentFile/detail/index.vue'),
      meta: { helpUrl: '', title: '商品开发档案详情' },
    },
    {
      path: '/archives-management/development-archive-order',
      name: 'developmentArchiveOrder',
      component: () =>
        import('@admin/views/plm/archivesManagement/developmentArchiveOrder/index.vue'),
      meta: { helpUrl: '', title: '商品开发档案变更单' },
    },
    {
      path: '/archives-management/development-archive-order/detail',
      name: 'developmentArchiveOrderDetail',
      component: () => import('@admin/views/plm/newDesign/detail/index.vue'),
      meta: { helpUrl: '', title: '商品开发档案变更单详情' },
    },
  ],
}

export default plmWorkflowSetupRouter
